export namespace AppIndexStyles {
    export const stepperContainer: React.CSSProperties = { background: '#F8F9FA', padding: 10, marginBottom: 24, height: 62, alignItems: 'center', width: '100%' };
}